import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Logo from "../Logo";

/** Shared sticky attribution bar across all concept layouts. */
export default function ConceptHeader({ industry }) {
  return (
    <div className="sticky top-0 z-50 bg-white border-b border-[#EBE8DF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 h-[64px] md:h-[72px] flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2 text-[#1A1A1A] shrink min-w-0" data-testid="attribution-home">
          <ArrowLeft size={16} className="shrink-0"/>
          <Logo height={32}/>
        </Link>

        <div className="hidden xl:flex items-center gap-3 text-[12px] text-[#5C5C5C] mx-4 truncate">
          <span className="label-eyebrow">Sample concept</span>
          <span>·</span>
          <span className="truncate">Fictional preview of a {industry.toLowerCase()} website.</span>
        </div>

        <Link
          to="/#contact"
          data-testid="attribution-cta"
          className="btn-primary text-[12px] sm:text-[13px] py-2 px-3 sm:py-2.5 sm:px-5 shrink-0 whitespace-nowrap"
        >
          <span className="hidden sm:inline">Request your concept</span>
          <span className="sm:hidden">Get a quote</span>
          <ArrowRight size={14}/>
        </Link>
      </div>
    </div>
  );
}
